import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';


const GallerySection = () => {
  // const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const images = [
    {
      src: '/assets/AdhyanPhotos01.jpg',
      title: 'Exterior View',
      description: 'Modern and inviting study space entrance'
    },
    {
      src: '/assets/AdhyanPhotos02.jpg',
      title: 'Study Area',
      description: 'Spacious and well-lit workstations'
    },
    {
      src: '/assets/AdhyanPhotos03.jpg',
      title: 'Private Desks',
      description: 'Individual study zones with storage'
    },
    {
      src: '/assets/AdhyanPhotos04.jpg',
      title: 'Study Hall',
      description: 'Quiet and focused environment'
    },
    {
      src: '/assets/AdhyanPhotos05.jpg',
      title: 'Workspace',
      description: 'Ergonomic seating and ample desk space'
    },
    {
      src: '/assets/AdhyanPhotos06.jpg',
      title: '2-Level Study Zone',
      description: 'Professional study environment'
    },
    {
      src: '/assets/AdhyanPhotos07.jpg',
      title: 'Interior',
      description: 'Clean and organized space'
    },
    {
      src: '/assets/AdhyanPhotos08.jpg',
      title: 'Interior',
      description: 'Clean and organized space'
    },
    {
      src: '/assets/AdhyanPhotos09.jpg',
      title: 'Interior',
      description: 'Clean and organized space'
    },
    {
      src: '/assets/AdhyanPhotos10.jpg',
      title: 'Interior',
      description: 'Clean and organized space'
    },
    {
      src: '/assets/AdhyanPhotos11.jpg',
      title: 'Interior',
      description: 'Clean and organized space'
    },
  ];


  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
  if (selectedIndex === null) return;

  const interval = setInterval(() => {
    nextImage();
  }, 2000); 

  return () => clearInterval(interval);
}, [selectedIndex]);

  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
            See Our Space
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Photo Gallery
          </h2>
          <p className="text-lg text-gray-600">
            Take a virtual tour of our premium study spaces and facilities
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              onClick={() => setSelectedIndex(index)}
              className="group relative rounded-2xl overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-300 aspect-4/3"
            >
              <img
                src={image.src}
                alt={image.title}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-white text-xl font-bold mb-1">{image.title}</h3>
                  <p className="text-gray-200 text-sm">{image.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
       {selectedIndex !== null && (
  <div
    className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-3 sm:p-6"
    onClick={() => setSelectedIndex(null)}
  >
    {/* Close Button */}
    <button
      className="absolute top-3 right-3 sm:top-6 sm:right-6 text-white bg-white/10 hover:bg-white/20 p-2 sm:p-3 rounded-full"
      onClick={() => setSelectedIndex(null)}
    >
      <X size={22} />
    </button>

    {/* Image Wrapper */}
    <div
      className="relative w-full max-w-[900px] flex flex-col items-center"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Image */}
      <img
        src={images[selectedIndex].src}
        alt={images[selectedIndex].title}
        className="w-full max-h-[65vh] object-contain rounded-xl"
      />

      {/* Prev Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          prevImage();
        }}
        className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 text-white bg-white/10 hover:bg-white/20 p-2 sm:p-3 rounded-full"
      >
        <ChevronLeft size={26} />
      </button>

      {/* Next Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          nextImage();
        }}
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white bg-white/10 hover:bg-white/20 p-2 sm:p-3 rounded-full"
      >
        <ChevronRight size={26} />
      </button>

      {/* Caption */}
      <div className="text-center mt-3 sm:mt-5 px-4">
        <h3 className="text-white text-lg sm:text-2xl font-bold">
          {images[selectedIndex].title}
        </h3>
        <p className="text-gray-300 text-sm sm:text-base">
          {images[selectedIndex].description}
        </p>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default GallerySection;
